import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Header.module.css';
import NavLink from '@/components/common/atoms/NavLink';
import Button from '@/components/common/Button';
import Logo from './img/logo.png';
import { setObjectInLS } from '@/util/localstorage';
import { unsetUser } from '@/store/actions/user/actions';
import { apiLogout } from '../../api';
import { refreshUnreadCounts as refreshUnreadCountsAction } from '@/store/actions/unread/actions';

const Header = () => {
  const dispatch = useDispatch();
  const inquiryUnreadCount = useSelector(state => state.unread?.inquiry || 0);
  const openChatUnreadCount = useSelector(state => state.unread?.openChat || 0);

  const refreshUnreadCounts = useCallback(() => {
    dispatch(refreshUnreadCountsAction());
  }, [dispatch]);

  useEffect(() => {
    refreshUnreadCounts();
    const timer = setInterval(refreshUnreadCounts, 60000); // 1分ごとに更新
    return () => clearInterval(timer);
  }, [refreshUnreadCounts]);

  const mainLinks = [{
    title: 'HOME',
    route: '/'
  }, {
    title: '楽曲\n一覧',
    route: '/music'
  }, {
    title: 'アーティスト\n一覧',
    route: '/creator'
  }, {
    title: 'おすすめ\n管理',
    route: '/recommendalbum'
  }, {
    title: 'メール\n管理',
    route: '/mail'
  }, {
    title: 'Playlist\n管理',
    route: '/playlist'
  }];

  const chatLinks = [{
    title: 'お問い合わせ管理',
    route: '/inquiry'
  }, {
    title: 'オープンチャット管理',
    route: '/openchat'
  }];

  const otherLinks = [{
    title: 'アルバム一覧',
    route: '/album'
  }, {
    title: '管理者管理',
    route: '/employee'
  }, {
    title: 'ポイント履歴',
    route: '/point'
  }, {
    title: '楽曲購入一覧',
    route: '/purchases'
  }, {
    title: 'ユーザタグ管理',
    route: '/songTag/manage'
  }, {
    title: 'お知らせ管理',
    route: '/news/edit'
  }];

  const memberLinks = [{
    title: '会員一覧',
    route: '/member'
  }, {
    title: 'メダル管理',
    route: '/medal'
  }];

  // 合算用
  const totalUnreadCount = inquiryUnreadCount + openChatUnreadCount;

  return (
    <header className={ styles.Header }>
      <div className={ styles.Container }>
        <img
          src={ Logo }
          alt='Digin Logo'
          className={ styles.Logo }
        />
        <ul className={ styles.Links }>
          { mainLinks.map((link, index) => (
            <li key={`nav-link-${index}`}>
              <NavLink
                route={link.route}
              >
                { link.title.split('\n').map( (text, index ) => (
                  <div  key={`nav-link-text-${index}`} >{text}</div>
                ))}
              </NavLink>
            </li>
            ))
          }

          <li className={styles.Dropdown}>
            <div className={styles.DropdownToggle}>会員管理 ▼</div>
            <ul className={styles.DropdownMenu}>
              {memberLinks.map((link, index) => (
                <li key={`member-link-${index}`}>
                  <NavLink route={link.route}>{link.title}</NavLink>
                </li>
              ))}
            </ul>
          </li>

          <li className={styles.Dropdown}>
            <div className={styles.DropdownToggle}>チャット管理 ▼</div>
            <div className={styles.DropdownToggle}>
              {/* チャット管理 ▼ */}
              {totalUnreadCount > 0 && (
                <span className={styles.UnreadBadge}>{totalUnreadCount}</span>
              )}
            </div>
            <ul className={styles.DropdownMenu}>
              {chatLinks.map((link, index) => (
                <li key={`chat-link-${index}`}>
                  <NavLink route={link.route}>
                    {link.title}
                    {link.route === '/inquiry' && inquiryUnreadCount > 0 && (
                      <span className={styles.UnreadBadge}>{inquiryUnreadCount}</span>
                    )}
                    {link.route === '/openchat' && openChatUnreadCount > 0 && (
                      <span className={styles.UnreadBadge}>{openChatUnreadCount}</span>
                    )}
                  </NavLink>
                </li>
              ))}
            </ul>
          </li>

          <li className={styles.Dropdown}>
            <div className={styles.DropdownToggle}>その他 ▼</div>
            <ul className={styles.DropdownMenu}>
              {otherLinks.map((link, index) => (
                <li key={`other-link-${index}`}>
                  <NavLink route={link.route}>{link.title}</NavLink>
                </li>
              ))}
            </ul>
          </li>

          <li>
            <Button
              color='Yellow'
              text='ログアウト'
              size='Small'
              onClick={async () => {
                await apiLogout();
                dispatch(unsetUser());
                setObjectInLS('user', {});
              }}
            />
          </li>
        </ul>
      </div>
    </header>
  );
};

export default Header;
